import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import viewRelatedAllCategories from './viewRelatedAllCategories';
import viewRelatedAllLives from './viewRelatedAllLives';
import viewAppCategoriesContent from './viewRelatedAppCategoriesContent';
import viewAppContent from './viewRelatedAppContentsMultiselectable';
import viewRelatedPlainImg from './viewRelatedPlainImg';
import viewRelatedInteractableGraphic from './viewRelatedInteractableGraphic';

export default {
  title: 'Poster Matrix',
  attributeName: 'posterMatrix',
  helpText: 'This section specifies if the app must enable the “Shared Experience” functionalities and some of its settings. This section is optional and if it’s not defined, all “Shared Experience” functionalities will be disabled.',
  fields: [
    {
      attributeName: 'appContent',
      label: 'App Content',
      type: FormInputTypes.RELATIONSHIP,
      canEdit: true,
      canCreate: true,
      configFile: [viewAppContent,viewAppCategoriesContent, viewRelatedAllCategories, viewRelatedPlainImg, viewRelatedInteractableGraphic],
      itemName: 'name',
      itemId: 'id',
      default: {},
      helpText: 'Select the content to show on the side panel',
    },
  ],
};
